import type { UseQueryOptions } from '@tanstack/react-query';
import type { PaginatedResponse, PaginationParams, SortParams } from '~/types';
import type { SavedContent, SortOptions } from '../types';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import HttpUtils from '~/agent/http-utils';
import { SAVED_CONTENT_API_ROOT } from '../constants';
import { savedContentKeys } from '../utils';

interface GetSavedContentParams extends PaginationParams, SortParams<SortOptions> {
  contentIds: string[];
}

export function getSavedContent(params: GetSavedContentParams): Promise<PaginatedResponse<SavedContent>> {
  return FetchPromise.get(HttpUtils.buildUriWithQueryString(`${SAVED_CONTENT_API_ROOT}`, params));
}

export function useSavedContentQuery(
  params: GetSavedContentParams,
  queryOptions: UseQueryOptions<PaginatedResponse<SavedContent>, JQuery.jqXHR> = {},
) {
  return useQuery<PaginatedResponse<SavedContent>, JQuery.jqXHR>(
    savedContentKeys.content(params),
    () => getSavedContent(params),
    queryOptions,
  );
}
